import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {UserService} from '../../../../../../@shared/services/user.service';
import {
  IUserLockHistory,
  LockActionEnum,
} from '../../../../../../@core/interfaces/user/user-lock.interface';

/**
 * Модалка журнала блокировок пользователя с СЕРВЕРНОЙ пагинацией (на юзера может быть много записей).
 * Открывается по кнопке со страницы ограничений; данные тянутся постранично через `getUserLockHistory`.
 */
@Component({
  selector: 'app-lock-history-modal',
  templateUrl: './lock-history-modal.component.html',
  styleUrls: ['./lock-history-modal.component.scss'],
})
export class LockHistoryModalComponent implements OnInit {
  public history: IUserLockHistory[] = [];
  public loading = false;
  public page = 1;
  public readonly pageSize = 20;
  public total = 0;

  public readonly LockActionEnum = LockActionEnum;

  constructor(
    private userService: UserService,
    private dialogRef: MatDialogRef<LockHistoryModalComponent>,
  ) {
  }

  ngOnInit(): void {
    this.loadPage(1);
  }

  /** Закрыть модалку (крестик в шапке, кнопка «Закрыть», переход по ссылке на админа). */
  public close(): void {
    this.dialogRef.close();
  }

  public get totalPages(): number {
    return Math.max(1, Math.ceil(this.total / this.pageSize));
  }

  /** Серверная пагинация журнала: грузим страницу по требованию (кнопки ←/→). */
  public loadPage(page: number): void {
    if (this.loading || page < 1 || (this.total && page > this.totalPages)) {
      return;
    }
    this.loading = true;
    this.userService.getUserLockHistory(page, this.pageSize).subscribe(
      res => {
        this.history = res?.history ?? [];
        this.total = res?.metadata?.amount ?? 0;
        this.page = page;
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }

  // Подпись «кто поставил»; для админа ID кликабелен (ссылка строится в шаблоне).
  public formatActor(actorType: string | null, actorId: number | null): string {
    if (actorType === 'auto') {
      return 'Автоблокировка';
    }
    if (actorType === 'self') {
      return 'Пользователь сам';
    }
    return 'Система';
  }
}
